import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const IconCheckbox = styled.span`
  font-size: ${pxToRem('14px')};
  color: ${props => props.theme.colors.mainBlue};
  ${props =>
    props.checked &&
    css`
      color: ${props.theme.colors.white};
      border-radius: ${pxToRem('3px')};
      background-image: ${props.theme.colors.gradient.checkbox};
    `};
`;
